export default "__VITE_ASSET__DvxByYyN__"